// Heuristic to detect the Spanish autonomous community from a tender record.
// Looks at contracting_authority + title; returns one of the 19 keys below or "" if unknown.
//
// This is intentionally permissive — many órganos NEVER mention the community
// in their name (ministry / state-wide bodies). For those we return "estatal".

const COMMUNITY_PATTERNS = [
    { key: "andalucia", label: "Andalucía", rx: /\b(Andaluc[ií]a|Sevill\w*|M[aá]laga|Granad\w*|C[oó]rdoba|Huelv\w*|Ja[eé]n\w*|Almer[ií]a|C[aá]diz)\b/i },
    { key: "aragon", label: "Aragón", rx: /\b(Arag[oó]n|Zaragoza|Huesca|Teruel)\b/i },
    { key: "asturias", label: "Asturias", rx: /\b(Asturias|Oviedo|Gij[oó]n|Avil[eé]s)\b/i },
    { key: "baleares", label: "Baleares", rx: /\b(Baleares|Mallorca|Menorca|Ibiza|Palma de Mallorca)\b/i },
    { key: "canarias", label: "Canarias", rx: /\b(Canarias|Tenerife|Las Palmas|Gran Canaria|Lanzarote|Fuerteventura|La Palma|La Gomera|El Hierro)\b/i },
    { key: "cantabria", label: "Cantabria", rx: /\b(Cantabria|Santander)\b/i },
    { key: "castilla_la_mancha", label: "Castilla-La Mancha", rx: /\b(Castilla-La Mancha|Castilla La Mancha|Toledo|Ciudad Real|Cuenca|Guadalajara|Albacete)\b/i },
    { key: "castilla_y_leon", label: "Castilla y León", rx: /\b(Castilla y Le[oó]n|Valladolid|Salamanca|Burgos|Le[oó]n|Zamora|Palencia|Segovia|Soria|[AÁ]vila)\b/i },
    { key: "cataluna", label: "Cataluña", rx: /\b(Catalu[nñ]a|Catalunya|Barcelona|Tarragona|Lleida|Girona|L'Hospitalet|Generalitat de Catalunya)\b/i },
    { key: "valencia", label: "C. Valenciana", rx: /\b(Comunitat Valenciana|C\.\s*Valenciana|Comunidad Valenciana|Valencia|Alicante|Castell[oó]n|Castell[oó]|L'Alcudia)\b/i },
    { key: "extremadura", label: "Extremadura", rx: /\b(Extremadura|C[aá]ceres|Badajoz|M[eé]rida)\b/i },
    { key: "galicia", label: "Galicia", rx: /\b(Galicia|Xunta de Galicia|A Coru[nñ]a|Coru[nñ]a|Pontevedra|Vigo|Ourense|Lugo|Santiago de Compostela)\b/i },
    { key: "madrid", label: "Madrid", rx: /\b(Madrid|Comunidad de Madrid|Alcal[aá] de Henares|Getafe|M[oó]stoles|Legan[eé]s|Fuenlabrada|Colmenar)\b/i },
    { key: "murcia", label: "Murcia", rx: /\b(Murcia|Cartagena|Lorca)\b/i },
    { key: "navarra", label: "Navarra", rx: /\b(Navarra|Pamplona|Nafarroa)\b/i },
    { key: "pais_vasco", label: "País Vasco", rx: /\b(Pa[ií]s Vasco|Euskadi|Bilbao|San Sebasti[aá]n|Vitoria|Gasteiz|Donostia|Bizkaia|Gipuzkoa|[AÁ]lava)\b/i },
    { key: "la_rioja", label: "La Rioja", rx: /\b(La Rioja|Logro[nñ]o)\b/i },
    { key: "ceuta", label: "Ceuta", rx: /\bCeuta\b/i },
    { key: "melilla", label: "Melilla", rx: /\bMelilla\b/i },
    { key: "estatal", label: "Estatal / AGE", rx: /\b(Ministerio\b|Estado\b|Administraci[oó]n General del Estado|AGE|SEPE|INSS|TGSS|RTVE|ADIF|RENFE|Tesorer[ií]a|INE)\b/i },
];

export const COMMUNITIES = COMMUNITY_PATTERNS.map(({ key, label }) => ({ key, label }));

export function detectCommunity(tender) {
    const haystack = [
        tender?.contracting_authority || "",
        tender?.title || "",
        tender?.organo || "",
    ]
        .filter(Boolean)
        .join(" · ");
    for (const p of COMMUNITY_PATTERNS) {
        if (p.rx.test(haystack)) return { key: p.key, label: p.label };
    }
    return null;
}

export function communityLabel(key) {
    const f = COMMUNITY_PATTERNS.find((p) => p.key === key);
    return f ? f.label : "—";
}
